/**
 * Canonical route path constants for this app.
 * For type-safe `.href()` / `.filter()` helpers, use `routes/sageRoutes` instead.
 */
export const BasePaths = {
  ADMIN: "/admin",
  SUPERADMIN: "/super",
  CASH_OFFICER: "/cash-officer",
  AUDITOR: "/auditor",
};

export const AuthPaths = {
  SIGNIN: "/signin",
  FORGOT_PASSWORD: "/forgot-password",
};

export const AdminPaths = {
  ADMIN_DASHBOARD: "/admin/admindashboard",
  MEMO_DOCUMENT: "/admin/workbench/memo-document",
  SIGN_DOCUMENT: "/admin/workbench/sign-document",
  FLUID_DOCUMENT: "/admin/workbench/fluid-document",
  REQUEST_MEMO_DOCUMENT: "/admin/requests/memo/memo-document",
  REQUEST_MEMO: "/admin/requests/memo",
  REQUEST_WORKFLOW: "/admin/requests/workflow",
  REQUEST_WORFLOW_DOCUMENT: "/admin/requests/workflow/document",
  GENERAL_DASHBOARD: "/admin/dashboard",
  ACTIVITIES: "/admin/activities",
  PERSONNELS: "/admin/personnels",
  FILES: "/admin/files/all",
  WORKFLOW: "/admin/workflows",
  WARRANTS: "/admin/warrants",
  EXPENDITURE_CLEARANCE: "/admin/expenditure-clearance",
  CREATE_PERSONNEL: "/admin/personnel/create",
  UPDATE_PERSONNEL: "/admin/personnel/update",
  MDAS: "/admin/mdas",
  AUDITOR_WORKBENCH: "/admin/audits",
  CREATE_MDA: "/admin/mda/create",
  MDA_DETAILS: "/admin/mdas/mda",
  WORKBENCH: "/admin/workbench",
  BULK_RUNNING_GRANT: "/admin/bulk-running-grant",
  SETTINGS: "/admin/settings",
  TEMPLATE: "/admin/template",
  BUDGET: "/admin/budget",
  BUDGET_UPLOAD: "/admin/budgets/upload",
  BUDGET_DETAILS: "/admin/budget/details",
  BUDGETS: "/admin/budgets",
  SPECIAL_APPROVAL: "/admin/budgets/special-approval",
  SPECIAL_APPROVAL_UPLOAD: "/admin/budgets/special-approval-upload",
  SPECIAL_APPROVAL_PREVIEW: "/admin/budgets/special-approval-preview",
  LEDGER: "/admin/ledger",
  CONTRACTS_LEDGER: "/admin/contracts",
  VOTE_BOOK: "/admin/votebook",
  PHASE_SEQUENCING: "/admin/settings/expense-management/phase-sequencing",
  WARRANT_REQUEST_PROCESSING: "/admin/phase-sequencing/warrant-request-processing",
  MDA_SECTOR_MAPPING: "/admin/settings/mda-sector-mapping",
  MDA_SETTINGS: "/admin/mdas/details/:id/settings",

  CONTRACT_DETAILS: "/admin/contract/details",

  GAM_ITEM: "/admin/settings/general-admin/item",
  GAM_CONTACT_INFORMATION: "/admin/settings/general-admin/contact-information",
  GAM_SECURITY_CONFIG: "/admin/settings/general-admin/security-configuration",
  REQUESTS: "/admin/requests",
  VOUCHERS: "/admin/vouchers",
  EMM_PHASE_SEQUENCING: "/admin/settings/expense-management/phase-sequencing",
  EMM_GENERAL_LEDGER: "/admin/settings/expense-management/general-ledger",
  EMM_DEDUCTIONS: "/admin/settings/expense-management/deductions",
  EMM_TEMPLATES: "/admin/settings/expense-management/templates",
  EMM_EXPENSE_CLASSIFICATION: "/admin/settings/expense-management/expense-classification",
  EMM_YEAR_END_PROCESS: "/admin/settings/expense-management/year-end-process",

  DMM_MINUTE_INK_COLOUR: "/admin/settings/document-management/minute-ink-colour",
  DMM_CODE_FORMAT: "/admin/settings/document-management/code-format",
  DMM_CLASSIFICATION: "/admin/settings/document-management/classification",

  EMM_RECONCILIATION_CLASSIFICATION:
    "/admin/settings/expense-management/reconciliation-classifications",
  EMM_DOCUMENT_CLASSIFICATION: "/admin/settings/expense-management/document-classifications",
  EMM_ITEM: "/admin/settings/expense-management/templates",

  WAM_CREATE: "/admin/settings/workflow-automation/workflows",
  WAM_STAMP: "/admin/settings/workflow-automation/stamps",
  WAM_ITEM: "/admin/settings/workflow-automation/item",

  BMM_MDA_SECTOR_MAPPING: "/admin/settings/budget-management/mda-sector-mapping",
  BMM_MDA_MAPPING: "/admin/settings/budget-management/mda-mapping",

  BMM_ITEM: "/admin/settings/budget-management/item",

  WARRANT_REQUEST_PROCESS_MDA:
    "/admin/settings/expense-management/phase-sequencing/mda-warrant-request-process",
  WARRANT_REQUEST_PROCESS_MINSTRY_OF_FINANCE:
    "/admin/settings/expense-management/phase-sequencing/mof-warrant-request-process",
  PAYMENTS: "/admin/payments",
  PAYMENT_ADVICE: "/admin/payment-advice",
  PAYMENT_LEDGER: "/admin/payment-ledger",
  PAYMENT_REQUEST_DIGITIZATION: "/admin/payments/payment-requests-digitization",
  PAYMENT_REQUESTS: "/admin/payment-requests",
  PAYMENT_TREASURY: "/admin/payment-advice/payment-treasury",
  RECONCILIATION: "/admin/reconciliation",
  PROFILE: "/admin/profile",
};

export const SuperAdminPaths = {
  INSTANCES: "/super/instances",
};

export const CashOfficerPaths = {
  PAYMENTS: "/cash-officer/payments",
};
